import { create } from 'zustand';

interface AuthState {
  isSignedIn: boolean;
  setSignedIn: (value: boolean) => void;
  checkAuth: () => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isSignedIn: localStorage.getItem('token') !== null,
  setSignedIn: (value: boolean) => set({ isSignedIn: value }),
  checkAuth: () => set({ isSignedIn: localStorage.getItem('token') !== null }),
  clearAuth: () => set({ isSignedIn: false }),
})); 